
import { FlowSheet, createFlowSheetFile, createTemplate, getTemplates, updateFlowSheetFile, updateTemplate } from "@/services/project/flowsheets"
import { useRequest } from "ahooks"
import { Form, Input, Modal, ModalProps } from "antd"
import TextArea from "antd/lib/input/TextArea"
import { useEffect } from "react"
import { createRoot } from "react-dom/client"
import { TemplateFormItem } from "./TemplateFormItem"

interface AddFlowSheetModalProps extends ModalProps {
  pId: string
  flowsheet?: FlowSheet.Modal
  isTemplate?: boolean
  onSuccess?: () => void
  onCancel?: () => void
}

export function AddFlowSheetModal(props: AddFlowSheetModalProps) {
  const {pId, flowsheet, onSuccess, onCancel, isTemplate = false} = props
  const [form] = Form.useForm()

  useEffect(() => {
    if (flowsheet) {
      form.setFieldsValue(flowsheet)
    }
  }, [])

  const onSave = async (body) => {
    if (flowsheet) {
      if (isTemplate) {
        await updateTemplate({...body}, {id: flowsheet.id})
      } else {
        if (body.template === undefined) {
          body.template = null
        }
        await updateFlowSheetFile({...body}, {id: flowsheet.id})
      }
    } else {
      body.content = ''
      if (isTemplate) {
        await createTemplate(body, pId)
      } else {
        await createFlowSheetFile(pId, body)
      }
    }
    onSuccess?.()
  }

  return <Modal
    {...props}
    width={660}
    maskClosable={false}
    okText="Save"
    open
    onOk={() => form.submit()}
    onCancel={onCancel}
  >
    <div>Add Flowsheet</div>
    <Form
      form={form}
      onFinish={(values) => {
        onSave(values)
      }}
      className="mt-4"
    >
      <Form.Item label='Name' name='name' rules={[{ required: true, message: 'Please enter file name' }]}>
        <Input type='text' />
      </Form.Item>
      <Form.Item label='Description' name='description'>
        <TextArea rows={3} />
      </Form.Item>
      {!isTemplate &&<Form.Item label='Template' name='template'>
        <TemplateFormItem pId={pId} />
      </Form.Item>}
    </Form>
  </Modal>
}

AddFlowSheetModal.show = (props: AddFlowSheetModalProps) => {
  const div = document.createElement('div')
  document.body.appendChild(div)
  const root = createRoot(div);
  root.render(<AddFlowSheetModal
    {...props}
    onCancel={() => {
      props.onCancel?.()
      root.unmount()
    }}
    onSuccess={() => {
      props.onSuccess?.()
      root.unmount()
    }}
  />);
}